import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import {
  ACCOUNT_BLOCKED_MASTER_ROUTE,
  ACCOUNT_BLOCKED_ROUTE,
  HOME_ROUTE,
  PAYWALL_MASTER_ROUTE,
} from '../main/main.data';
import { NavigationService } from '../navigation/navigation.service';
import { map } from 'rxjs/operators';
import { FeaturesDataStore } from '../features-data/features-data.store';

@Injectable({
  providedIn: 'root',
})
export class AccountBlockedGuard implements CanActivate, CanActivateChild {
  constructor(
    private _navigationService: NavigationService,
    private _featuresDataStore: FeaturesDataStore
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (state.url.indexOf(PAYWALL_MASTER_ROUTE) === 0) {
      return of(true);
    }

    return this._featuresDataStore.isAccountBlocked$.pipe(
      map((isAccountBlocked: boolean) => {
        if (isAccountBlocked) {
          if (state.url === ACCOUNT_BLOCKED_MASTER_ROUTE) {
            return true;
          }
          this._navigationService.goTo([ACCOUNT_BLOCKED_ROUTE], {
            replaceUrl: true,
          });
          return false;
        } else if (state.url === ACCOUNT_BLOCKED_MASTER_ROUTE) {
          this._navigationService.goTo([HOME_ROUTE], { replaceUrl: true });
          return false;
        }
        return true;
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(next, state);
  }
}
